import { addMinutes } from 'date-fns'

import { getDateFromAppointment } from './getDateFromAppointment'

import type { Appointment } from '../../models/appointment/Appointment'

/**
 * @return a Date representing the end of the appointment, computed as start time + appointmentDuration minutes
 */
export function getEndDateFromAppointment(
  appointment: Pick<Appointment, 'startDate' | 'startTime' | 'timeZone' | 'appointmentDuration'>,
): Date {
  return addMinutes(getDateFromAppointment(appointment), appointment.appointmentDuration)
}
